import type { ComputedRef } from 'vue';

import { DirectSaleComputedState } from '~/apiClient';
import { isAuction, isDirectSale, isOfflineSale, type SaleItemEntity, type SaleListingItemEntity } from '~/types/sale.type';

type UseSalePriceParams = MaybeRefOrGetter<SaleItemEntity | SaleListingItemEntity>;

type UseSalePriceReturn = {
    price: ComputedRef<number | undefined>;
};

export const useSalePrice = (sale: UseSalePriceParams): UseSalePriceReturn => {
    // DATA
    // The price a sale shows on its cards and its detail page alike
    const price = computed(() => {
        const _sale = toValue(sale);

        if (isAuction(_sale)) return _sale.clearingPrice ?? _sale.currentPrice;
        if (isDirectSale(_sale) && _sale.computedState === DirectSaleComputedState.NoActiveOrder) return _sale.buyNowPrice ?? undefined;
        if (isDirectSale(_sale)) return _sale.clearingPrice ?? _sale.price;
        if (isOfflineSale(_sale)) return _sale.price ?? undefined;

        return _sale.purchasePrice ?? _sale.sellingPrice ?? undefined;
    });

    return { price };
};
